export interface FilterOption {
  id: number;
  name: string;
}

export function filterOptionsBySearch<T extends FilterOption>(
  options: T[],
  search: string,
): T[] {
  const query = search.trim().toLowerCase();
  if (!query) {
    return options;
  }

  return options.filter((option) =>
    option.name.toLowerCase().includes(query),
  );
}

export function toVirtualCheckboxItems<T extends FilterOption>(
  options: T[],
): { id: number; label: string }[] {
  return options.map((option) => ({
    id: option.id,
    label: option.name,
  }));
}
